<script>
import _ from 'lodash'
export default {
  computed: {
    isCreate () {
      return this.mode === 'create'
    },
    isEdit () {
      return this.mode === 'edit'
    },
    isView () {
      return this.mode === 'view'
    }
  },
  methods: {
    loadFromStore (section, fieldsToOmit) {
      const campaign = _.cloneDeep(this.$store.getters['campaignDesigner/state'].currentCampaign)

      // Map flat fields
      Object.keys(campaign).forEach(field => {
        if (this.$data.hasOwnProperty(field)) {
          const value = _.cloneDeep(campaign[field])

          if (value !== undefined) {
            if (typeof value === 'object' && value && value.selected !== undefined) {
              this.$data[field] = _.cloneDeep(value.selected)
            } else {
              this.$data[field] = _.cloneDeep(value)
            }
          }
        }
      })

      // Map config fields
      if (campaign.config[section]) {
        Object.keys(campaign.config[section]).forEach(data => {
          if (this.$data.hasOwnProperty(data)) {
            const value = _.cloneDeep(campaign.config[section][data])
            if (value !== undefined) {
              if (typeof value === 'object' && value && value.selected !== undefined) {
                this.$data[data] = _.cloneDeep(value.selected)
              } else {
                this.$data[data] = _.cloneDeep(value)
              }
            }
          }
        })
      }

      return campaign
    }
  }
}
</script>
